import React from 'react'
import Footer from '../../Layout/Footer'
import Header from '../../Layout/Header'
import FAQ from './FAQ'
import SeoTagsFooter from './SeoTagsFooter'

function PrivacyPolicy() {
  return (
    <div className="page_wrapper">
      <Header/>
      <main className="page_content">

        {/* Page Header */}
        <section 
          className="page_header text-center bg-dark section_decoration overflow-hidden" 
          style={{backgroundImage :"url('assets/images/backgrounds/page_header_bg_1.webp')"}}
        >
          <div className="container">
            <h1 className="page_title text-white">Privacy Policy</h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li><a href="/">Home</a></li>
              <li className="active"><a href="#!">Privacy Policy</a></li>
            </ul>
          </div>
          <div className="decoration_item shape_nate">
            <img src="assets/images/shapes/shape_nate.svg" alt="Shape Nate"/>
          </div>
        </section>

        {/* Privacy Policy Content */}
        <section className="feature_section section_space">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="heading_block mb-4 text-center">
                
                  <p className="heading_description mb-0" style={{textAlign:'left'}}>
                    Mokshiq (a product of <strong>Rakle Service Private Limited</strong>, “The Company”) values your privacy and is committed to protecting your personal data. 
                    This Policy explains how we collect, use, store, secure, and dispose of your information.
                  </p>
                </div>

                <div className="policy_content">
                  <h4>1. Definitions</h4>
                  <p><strong>Personal Information:</strong> Any information that relates to a natural person which can directly or indirectly identify them.</p>
                  <p><strong>Sensitive Personal Data or Information:</strong> Includes but is not limited to:</p>
                  <ul>
                    <li>Password</li>
                    <li>Bank account, credit/debit card, or other payment details</li>
                    <li>Biometric information (for AEPS 2FA merchant authentication)</li>
                    <li>Detail relating to identity verification (PAN, Aadhaar, GSTIN)</li>
                  </ul>
                  <p>
                    Information that is publicly available or furnished under the Right to Information Act, 2005, 
                    is not considered sensitive.
                  </p>

                  <h4>2. Applicability</h4>
                  <p>
                    This Policy applies to all personal and sensitive information collected by Mokshiq, 
                    its parent company Rakle Service Private Limited, websites, mobile apps, and electronic communication channels. 
                  </p>

                  <h4>3. Purpose of Collection &amp; Use</h4>
                  <p>
                    Mokshiq collects and uses information for financial transaction processing, identity verification (Verify), regulatory compliance, and customer support. 
                    We do not sell or share your personal data to unauthorized third parties.
                  </p>

                  <h4>4. Contact &amp; Grievance Officer</h4>
                  <p>
                    For any grievances, discrepancies, or privacy-related issues, please contact our support team at: <br/>
                    Email: <a href="mailto:support@mokshiq.in">support@mokshiq.in</a> | Phone: <a href="tel:+917311104571">+91 7311104571</a><br/>
                    Address: 1st Floor, C 78, Sector-2 Noida, Uttar Pradesh
                  </p>

                  <h4>5. Data Retention Policy</h4>
                  <p>
                    We retain personal data for statutory time periods prescribed under Indian laws, after which it is securely disposed of. 
                    Mokshiq complies with the <strong>Information Technology Act, 2000</strong> and 
                    the <strong>IT Rules 2011</strong>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FAQ 
          title="Privacy & Security FAQs"
          subtitle="How Mokshiq and Rakle Service Private Limited protect customer data and payment transactions."
        />

      </main>
      <Footer/>
      <SeoTagsFooter/>
    </div>
  )
}

export default PrivacyPolicy
